import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Icon, IconButton, Menu, MenuItem,
} from '@material-ui/core';
import { ChangePasswordDialog } from '@smorder/core';
import EmailReportsDialog from '../../../components/email-reports-dialog';

class UserIcon extends Component {
  constructor(props) {
    super(props);

    this.state = {
      anchorEl: null,
      passwordDialogOpen: false,
      emailReportsDialogOpen: false,
    };
  }

  handleClick = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  updatePassword = (oldPassword, newPassword, confirmPassword) => {
    const { changePassword } = this.props;
    changePassword(oldPassword, newPassword, confirmPassword);
    this.setState({ passwordDialogOpen: false });
  }

  renderMenu() {
    const { onLogout, loggedIn } = this.props;
    const { anchorEl } = this.state;
    const open = Boolean(anchorEl);

    if (!loggedIn) {
      return null;
    }

    return (
      <Menu
        id="menu"
        anchorEl={anchorEl}
        open={open}
        onClose={this.handleClose}
        PaperProps={{
          style: {
            width: 200,
          },
        }}
        disableAutoFocusItem
      >
        <MenuItem onClick={() => this.setState({ emailReportsDialogOpen: true, anchorEl: null })}>
          E-Mail Reports
        </MenuItem>
        <MenuItem onClick={() => this.setState({ passwordDialogOpen: true, anchorEl: null })}>
          Passwort ändern
        </MenuItem>
        <MenuItem onClick={onLogout}>
          Logout
        </MenuItem>
      </Menu>
    );
  }

  render() {
    const { anchorEl, passwordDialogOpen, emailReportsDialogOpen } = this.state;
    const open = Boolean(anchorEl);

    return (
      <div>
        <IconButton
          aria-label="Logout"
          aria-owns={open ? 'menu' : undefined}
          aria-haspopup="true"
          onClick={this.handleClick}
          color="inherit"
        >
          <Icon>account_circle</Icon>
        </IconButton>

        {this.renderMenu()}
        <ChangePasswordDialog
          open={passwordDialogOpen}
          onCancel={() => this.setState({ passwordDialogOpen: false })}
          onSubmit={this.updatePassword}
        />
        <EmailReportsDialog
          open={emailReportsDialogOpen}
          onCancel={() => this.setState({ emailReportsDialogOpen: false })}
        />
      </div>
    );
  }
}

UserIcon.propTypes = {
  onLogout: PropTypes.func.isRequired,
  changePassword: PropTypes.func.isRequired,
  loggedIn: PropTypes.bool.isRequired,
};

export default UserIcon;
